import { render, staticRenderFns } from "./ligIndex.vue?vue&type=template&id=b5895e32&scoped=true&"
import script from "./ligIndex.vue?vue&type=script&lang=js&"
export * from "./ligIndex.vue?vue&type=script&lang=js&"
import style0 from "./ligIndex.vue?vue&type=style&index=0&id=b5895e32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5895e32",
  null
  
)

export default component.exports